import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import {useTranslation} from 'react-i18next';
import {loginUser} from '@store/reducers/auth';
import {setWindowClass} from '@app/utils/helpers';
import {PfButton, PfCheckbox} from '@profabric/react-components';

import {JSEncrypt} from 'jsencrypt';

import * as Yup from 'yup';

import {Form, InputGroup} from 'react-bootstrap';
import * as AuthService from '../../services/auth';
import Navmenu from './Navmenu';

const Login = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [serviceid, setServiceid] = useState(
    searchParams.get('serviceid') || '5009'
  );
  const [isAuthLoading, setAuthLoading] = useState(false);
  const [isGoogleAuthLoading, setGoogleAuthLoading] = useState(false);
  const [isFacebookAuthLoading, setFacebookAuthLoading] = useState(false);
  const [is365AuthLoading, set365AuthLoading] = useState(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [t] = useTranslation();

  // useEffect(() => {
  //   setServiceid(searchParams.get('serviceid') as string);
  // }, []);

  // setServiceid(searchParams.get('serviceid') as string);

  const login = async (email: string, password: string) => {
    try {
      //RSA
      const encrypt = new JSEncrypt();
      const pub_key = `
-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDBt/cKQ43LoiQ0gk3e2tkxtx+C
MWBw68mpbO2nkOycWLung5nu47I0pC8uhTyxMaLUEpGXwVOLs8fqmZdClmwplPsm
cZZKcrTUS6n4TjP7+HPwnCxKlCv0099E8UZPNMs/QTEq2kOYFdT5bV4DtFHt9TbL
duzwZYh1YnjpjWDgkQIDAQAB
-----END PUBLIC KEY-----`;
      encrypt.setPublicKey(pub_key);
      const password_ciphertext = encrypt.encrypt(password);
      setAuthLoading(true);
      const data = await AuthService.loginByAuth(email, password_ciphertext, serviceid);
      toast.success('Login is succeed!');
      setAuthLoading(false);
      let hash =
        '&signed_request=' +
        encodeURIComponent(data.hash.replace(/-/g, '=').replace(/@/g, '+'));
      // let url = Buffer.from(data.redirect, 'base64')
      //   .toString('utf-8')
      //   .concat(hash);
      let url = '/trip-make';
      console.log(url);
        console.log(url);
      setTimeout(() => (window.location.href = url), 2000);
    } catch (error: any) {
      setAuthLoading(false);
      toast.error(error.message || 'Failed');
    }
  };

  const loginBy365 = async () => {
    try {
      set365AuthLoading(true);
      const params = await AuthService.loginBy365(serviceid);
      toast.success('Login is succeeded!');
      set365AuthLoading(false);
      let hash =
        '&signed_request=' +
        encodeURIComponent(params.hash.replace(/-/g, '=').replace(/@/g, '+'));
      // let url = Buffer.from(params.redirect, 'base64')
      //   .toString('utf-8')
      //   .concat(hash);
      let url = '/trip-make';
      console.log(url);
      setTimeout(() => (window.location.href = url), 2000);
      //window.location.href = url;
    } catch (error: any) {
      set365AuthLoading(false);
      toast.error(error.message || 'Failed');
    }
  };

  const loginByGoogle = async () => {
    try {
      setGoogleAuthLoading(true);
      const token = await AuthService.loginByGoogle();
      toast.success('Login is succeeded!');
      setGoogleAuthLoading(false);
      dispatch(loginUser(token));
      navigate('/');
    } catch (error: any) {
      setGoogleAuthLoading(false);
      toast.error(error.message || 'Failed');
    }
  };

  const {handleChange, values, handleSubmit, touched, errors} = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: Yup.object({
      // email: Yup.string().email('Invalid email address').required('Required'),
      email: Yup.string().required('Required'),
      password: Yup.string()
        .min(5, 'Must be 5 characters or more')
        .max(30, 'Must be 30 characters or less')
        .required('Required')
    }),
    onSubmit: (values) => {
      login(values.email, values.password);
    }
  });

  setWindowClass('hold-transition login-page2');

  return (
    <>
      <Navmenu></Navmenu>
      <div className="login-box">
        <div className="card card-outline card-primary">
          <div className="card-header text-center">
            <div className="logo">
              <img
                src="https://api-passport.advanceagro.net/img/aa.png"
                alt=""
              />
            </div>
            <div className="h4">DoubleA Passport</div>
          </div>
          <div className="card-body">
            <p className="login-box-msg">{t<string>('login.label.signIn')}</p>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <InputGroup className="mb-3">
                  <Form.Control
                    id="email"
                    name="email"
                    placeholder="Username"
                    onChange={handleChange}
                    value={values.email}
                    isValid={touched.email && !errors.email}
                    isInvalid={touched.email && !!errors.email}
                  />
                  {touched.email && errors.email ? (
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  ) : (
                    <InputGroup.Append>
                      <InputGroup.Text>
                        <i className="fas fa-user" />
                      </InputGroup.Text>
                    </InputGroup.Append>
                  )}
                </InputGroup>
              </div>
              <div className="mb-3">
                <InputGroup className="mb-3">
                  <Form.Control
                    id="password"
                    name="password"
                    type="password"
                    placeholder="Password"
                    onChange={handleChange}
                    onKeyUp={(event) => {
                      if (event.code === 'Enter') {
                        event.preventDefault();
                        login(values.email, values.password);
                        //document.querySelector('form')!.submit();
                      }
                    }}
                    value={values.password}
                    isValid={touched.password && !errors.password}
                    isInvalid={touched.password && !!errors.password}
                  />
                  {touched.password && errors.password ? (
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  ) : (
                    <InputGroup.Append>
                      <InputGroup.Text>
                        <i className="fas fa-lock" />
                      </InputGroup.Text>
                    </InputGroup.Append>
                  )}
                </InputGroup>
              </div>

              <div className="row">
                <div className="col-5 invisible">
                  <PfCheckbox checked={false}>
                    {t<string>('login.label.rememberMe')}
                  </PfCheckbox>
                </div>
                <div className="col-7">
                  <PfButton
                    theme="success"
                    block
                    type="submit"
                    loading={isAuthLoading}
                    disabled={
                      isFacebookAuthLoading ||
                      isGoogleAuthLoading ||
                      is365AuthLoading
                    }
                  >
                    {t<string>('login.button.signIn.social', {what: 'IDMS'})}
                  </PfButton>
                </div>
              </div>
            </form>
            <hr></hr>
            <div className="social-auth-links text-center mt-2 mb-3">
              <PfButton
                block
                className="mb-2"
                onClick={loginBy365}
                loading={is365AuthLoading}
                disabled={isAuthLoading || isGoogleAuthLoading}
              >
                <img
                  className="mr-2 mb-1"
                  width={'16px;'}
                  src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMC8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvVFIvMjAwMS9SRUMtU1ZHLTIwMDEwOTA0L0RURC9zdmcxMC5kdGQnPjxzdmcgaGVpZ2h0PSIzMiIgc3R5bGU9Im92ZXJmbG93OnZpc2libGU7ZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMiAzMiIgdmlld0JveD0iMCAwIDMyIDMyIiB3aWR0aD0iMzIiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnPjxnIGlkPSJNaWNyb3NvZnRfMV8iPjxnIGlkPSJNaWNyb3NvZnQiPjxnIGlkPSJCbHVlX3g1Rl9TcXVhcmUiPjxyZWN0IGhlaWdodD0iMTUiIHN0eWxlPSJmaWxsOiM1MUFFRDk7IiB3aWR0aD0iMTUiIHk9IjE3Ii8+PC9nPjxnIGlkPSJZZWxsb3dfeDVGX1NxdWFyZSI+PHJlY3QgaGVpZ2h0PSIxNSIgc3R5bGU9ImZpbGw6I0ZFQzMyNzsiIHdpZHRoPSIxNSIgeD0iMTciIHk9IjE3Ii8+PC9nPjxnIGlkPSJHcmVlbl94NUZfU3F1YXJlIj48cmVjdCBoZWlnaHQ9IjE1IiBzdHlsZT0iZmlsbDojMzRCNjdBOyIgd2lkdGg9IjE1IiB4PSIxNyIvPjwvZz48ZyBpZD0iT3JhbmdlX3g1Rl9TcXVhcmUiPjxyZWN0IGhlaWdodD0iMTUiIHN0eWxlPSJmaWxsOiNGMTU3MjM7IiB3aWR0aD0iMTUiLz48L2c+PC9nPjwvZz48L2c+PC9zdmc+"
                />
                {/* <i className="fab fa-microsoft mr-2" /> */}
                {t<string>('login.button.signIn.social', {
                  what: '365'
                })}
              </PfButton>
              {/* <PfButton
              block
              theme="danger"
              onClick={loginByGoogle}
              loading={isGoogleAuthLoading}
              disabled={isAuthLoading || isFacebookAuthLoading}
            >
              <i className="fab fa-google mr-2" />
              {t<string>('login.button.signIn.social', {what: 'Google'})}
            </PfButton> */}
            </div>
            <p className="mb-1 d-none">
              <a
                href="https://api-passport.advanceagro.net/oauth/idms/reset-password"
                target={'_blank'}
              >
                {t<string>('login.label.forgotPass')}
              </a>
              {/* <Link to="/forgot-password">
              {t<string>('login.label.forgotPass')}
            </Link> */}
            </p>
            <p className="mb-0 d-none">
              <a
                href="https://passwordreset.microsoftonline.com"
                target={'_blank'}
              >
                {t<string>('login.label.forgotPass365')}
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
